import { useContract } from '@thirdweb-dev/react';
import { useConfig } from '@app/config';
import nftMarketplaceAbi from 'abis/NFTMarketPlace.json';
import { useAsyncFn } from 'react-use';
import { useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { showErrorToast } from '@app/components/Toast';

export function useMakeAnOffer() {
  const config = useConfig();

  const queryClient = useQueryClient();

  const { contract } = useContract(
    config?.CONTRACTS.NFT_MARKETPLACE,
    nftMarketplaceAbi
  );

  const [{ loading }, makeAnOffer] = useAsyncFn(
    async ({ listingId, amount, extraData, optionalPremiumTokenId }) => {
      if (!contract) {
        return;
      }

      try {
        const res = await contract.call('bidForNFT', [
          listingId,
          amount,
          optionalPremiumTokenId,
          extraData
        ]);

        if (res?.receipt?.transactionHash) {
          await queryClient.invalidateQueries({
            queryKey: [QueryKeys.GET_BEST_BID_FOR_LISTING]
          });
          await queryClient.invalidateQueries({
            queryKey: [QueryKeys.GET_TOKEN_BALANCE]
          });
          await queryClient.invalidateQueries({
            queryKey: [QueryKeys.GET_NFT_MARKETPLACE_OFFERS]
          });

          return res?.receipt.transactionHash;
        }
      } catch (e) {
        showErrorToast(`Transaction failed`);
        console.error(e);
      }
    },
    [contract, queryClient]
  );

  return {
    makeAnOffer,
    isLoading: loading
  };
}
